<template>
	<button
		ref="target"
		class="animation-killswitch"
		:aria-label="ariaLabel"
		@click="onClick"
	>
		<slot v-if="animStore.hasAnimation" name="animation"></slot>
		<slot v-if="!animStore.hasAnimation" name="no-animation"></slot>
	</button>
</template>

<script>
export default {
	name: 'AnimationKillswitch',
	props: {
		animKillswitchAriaLabelTurnOff: {
			type: String,
			required: false,
			default: '',
		},
		animKillswitchAriaLabelTurnOn: {
			type: String,
			required: false,
			default: '',
		},
	},

	data() {
		return {
			ariaLabel: this.$props.animKillswitchAriaLabelTurnOff,
			animStore: this.$store.state,
			bodyNoAnimClass: 'no-anim',
			toggleAnimEventName: 'toggle-all-animations',
		};
	},
	watch: {
		animStore: {
			deep: true,
			handler: function () {
				const bodyClass = document.querySelector('body').classList;

				if (this.animStore.hasAnimation) {
					bodyClass.remove(this.bodyNoAnimClass);
				} else {
					bodyClass.add(this.bodyNoAnimClass);
				}
			},
		},
	},

	methods: {
		onClick() {
			this.$store.commit('toggleAnimation');
			if (this.ariaLabel == this.$props.animKillswitchAriaLabelTurnOff) {
				this.ariaLabel = this.$props.animKillswitchAriaLabelTurnOn;
			} else {
				this.ariaLabel = this.$props.animKillswitchAriaLabelTurnOff;
			}
			this.$refs.target.setAttribute('aria-label', this.ariaLabel);
		},
		onClickElse() {
			this.$store.commit('updateRunId', Date.now());
		},
	},
};
</script>

<style lang="scss"></style>
